import * as React from "react";
import Listup from "./listup";
import { othersData } from "../data";
import { getLocalizedText } from "../util";
import { useLang } from "../lang";

const Others: React.FC = () => {
  const { langEn } = useLang();
  return (
    <div id="others" className="container justify-content-center mb-3">
      <p className="title">{langEn ? "Others" : "その他"}</p>

      <div className="row text-left">
        {othersData.map((item, i) => (
          <Listup
            key={i}
            items={item.contents}
            title_en={getLocalizedText(item.title, true)}
            title_ja={getLocalizedText(item.title, false)}
          />
        ))}
      </div>
    </div>
  );
};

export default Others;
